import React from 'react';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import { numberWithCommas } from 'ps-components/lib/formatters';
import './InternalDataColumn.scss';

class InternalDataColumn extends React.Component {
  static propTypes = {
    data: arrayOf(
      shape({
        key: string,
        value: oneOfType([number, string])
      })
    ),
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    )
  };

  getKeyValuePairs = () => {
    const { data } = this.props;

    return data.map((dataPoint, index) => {
      const dataPairClass =
        index === 0 ? 'comp-sum-internal-data__pairs comp-sum-internal-data__row-one' : 'comp-sum-internal-data__pairs';
      return (
        <div key={index} className={dataPairClass}>
          <span className="comp-sum-internal-data__key">
            {dataPoint.key.includes('${') ? this.getMappedKey(dataPoint.key) : dataPoint.key}
          </span>
          <span className="comp-sum-internal-data__value">{dataPoint.value}</span>
        </div>
      );
    });
  };

  getMappedKey = value => {
    const { replacementTokens } = this.props;
    return replacementTokens.find(replacement => value.includes(replacement.token)).value;
  };

  render() {
    return <div className="comp-sum-internal-data__column">{this.getKeyValuePairs()}</div>;
  }
}

export default InternalDataColumn;
